import Utilities from "@/common/utilities";
import Helper from "@/common/helper.js"
import { TransactionStatusTypes } from "@/common/enums";


export default class ReportOrderTransactionHistoryModel {    
    timestamp: number | undefined;
    status: TransactionStatusTypes | undefined;
    statusDisplay: string | undefined;
    
    get timestampDisplay(): string {        
        let local = Helper.convertUTCDateToLocalDate(new Date(this.timestamp!))        
        return local.toDateString().substring(4) + ", " + local.toLocaleTimeString()
    }

    get timestampDate(): string {        
        let local = Helper.convertUTCDateToLocalDate(new Date(this.timestamp!))        
        return local.yyyy_mm_dd()
    }


    static from(json: string): ReportOrderTransactionHistoryModel {
        let model = Object.assign(new ReportOrderTransactionHistoryModel(), json);
                
        return model;
    }

}